import type { SequenceOtherState } from '~/components/Sequence/sequenceOtherStates';
import { nodeStatusLabel } from '~/components/Sequence/sequenceSteps';

/**
 * The "Other states" pile's tooltip: the prose explaining what the pile is, then an ITEMISED breakdown of
 * the exact journey states feeding it (biggest first — see {@link otherStatesFrom}, which orders the avatar
 * sample the same way so the faces beside this list belong to the states it names first).
 *
 * The breakdown is the point. A bare count on an anonymous amber pill tells a rep that N people are
 * somewhere unnamed and gives them no way to find out — the only recourse is opening faces one at a time.
 * Naming the states turns the pile into a diagnosis ("41 waiting for working hours, 12 needs attention"),
 * and makes a state that should have been folded into a stage obvious the moment it starts collecting people.
 *
 * Named states are the EDITOR's case. On the full-journey graph the pile holds, by construction, only ids
 * the diagram doesn't draw — and `nodeStatusLabel` reads its copy from those same `FLOW2_NODES` — so every
 * row there falls back to the raw node id. That is the useful output on that surface: the id is the only
 * clue to which engine state has drifted off the diagram, and `FLOW_JOURNEY_NODES` carries no titles to
 * borrow instead.
 */
export function SequenceOtherStatesTooltip({ intro, states }: { intro: string; states: SequenceOtherState[] }) {
  return (
    <div className="flex flex-col gap-1.5 text-left">
      <span>{intro}</span>
      <ul className="flex flex-col gap-0.5">
        {states.map((s) => (
          <li key={s.nodeId} className="flex items-baseline justify-between gap-4">
            <span>{nodeStatusLabel(s.nodeId)}</span>
            <span className="tabular-nums opacity-70">{s.count}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
